"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const filter_utils_1 = require("../utils/filter-utils");
exports.SearchUnit = (props) => {
    const [value, setValue] = react_1.default.useState(props.value || '');
    const { name, onChange, placeholder, wait } = props;
    const memoizedDebounce = react_1.useMemo(() => filter_utils_1.debounce(wait), [wait]);
    const handleChange = (e) => {
        const value = e.target.value;
        const v = { name: String(name), value };
        memoizedDebounce(() => {
            onChange(v);
        });
        setValue(value);
    };
    return (react_1.default.createElement(TextField_1.default, { name: String(name), value: value, onChange: handleChange, placeholder: placeholder }));
};
